'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_js_defined$() {
}
export { $c_sjs_js_defined$ as $c_sjs_js_defined$ };
$p = $c_sjs_js_defined$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
}
export { $h_sjs_js_defined$ as $h_sjs_js_defined$ };
$h_sjs_js_defined$.prototype = $p;
$p.So = (function(a) {
  return a;
});
var $d_sjs_js_defined$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_js_defined$, "scala.scalajs.js.defined$", ({
  vX: 1
}));
export { $d_sjs_js_defined$ as $d_sjs_js_defined$ };
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$();
  }
  return $n_sjs_js_defined$;
}
export { $m_sjs_js_defined$ as $m_sjs_js_defined$ };
